export const isNavigatingAway = (current: number, next: number) => current !== next;

export const isNavigatingAwayFrom = (from: number, current: number, next: number) =>
  from === current && isNavigatingAway(current, next);
